exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle-checkbox button {\n  min-width: 44px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/components/toggle-checkbox/toggle-checkbox.component.scss
// module id = ../../../../../resources/assets/src/app/shared/components/toggle-checkbox/toggle-checkbox.component.scss
// module chunks = main